<template>
    <div>
        <h1>TREATMENT GOALS</h1>
        <v-layout>
            <v-text-field v-model="name" solo label="Name"></v-text-field>
            <v-btn :disabled="(name!=null&&name!='')?false:true" @click="createGoal" text color="success">add new Goal</v-btn>
        </v-layout>
        <v-layout>
            <v-text-field @input="seatchMethod" v-model="search" solo label="Search"></v-text-field>
        </v-layout>
        <v-layout v-if="goals != null">
            <v-data-table
      v-if="goals.length"
      :headers="[
        /* { text: 'NUMBER', value: 'id_playlist' }, */
        { text: 'ID', value: 'id' },
        { text: 'ORDER', value: 'index_order' },
        { text: 'NAME', value: 'name' },
        { text: 'HIGHLIGHTED GOAL', value: 'highlighted_goal'},
        { text: 'EDIT', value: 'edit'},
        { text: 'DELETE', value: 'actions'},
        
      ]"
      :items="filteredGoals"
    >
    <template v-slot:item.actions="{ item }">
    <v-btn @click="deleteItem(item)" text color="error">DELETE</v-btn>
    </template>
    <template v-slot:item.edit="{ item }">
    <v-btn @click="edit(item)" text color="info">Edit</v-btn>
    </template>
    </v-data-table>
    <v-dialog
        v-model="dialog"
        v-if="selected!=null"
        width="500"
    >
      <v-card>
        <v-card-title
            class="headline grey lighten-2"
            primary-title
        >
          Updating
        </v-card-title>

        <v-card-text>
          <v-text-field v-model="selected.name" label="Name"></v-text-field>
        </v-card-text>
        <v-card-text>
          <v-text-field v-model="selected.index_order" label="Order"></v-text-field>
        </v-card-text>
        <v-card-text>
          <v-switch v-model="selected.highlighted_goal" label="Highlighted Goal" />
        </v-card-text>
        <v-divider></v-divider>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="success"
              flat
              @click="update"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        </v-layout>
    </div>
</template>
<script>
import Axios from 'axios';

export default {
    data() {
        return {
            name: null,
            goals: null,
            filteredGoals: null,
            search: '',
            selected: null,
            dialog:false,
        }
    },
    methods: {
        async update()
        {
            if(this.selected.name !=null && this.selected.name != "")
            await axios
                .post("/admin/treatment/updateGoal", {
                    id: this.selected.id,
                    name: this.selected.name,
                    index_order: this.selected.index_order,
                    highlighted_goal: this.selected.highlighted_goal
                }).then(()=>{
                    this.sync();
                    // this.selected.name = null;
                    // this.selected.id = null,
                    this.dialog = false;
                })
        },
        edit(item)
        {
            this.selected = Object.assign({}, item);
            this.dialog = true;
        },
        seatchMethod(val)
        {
            if(this.search=='')
            {
                this.filteredGoals = this.goals.sort((a, b) => {
  const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
  const nameB = b.name.toUpperCase();

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0; // Names are equal
});
;;
            }
            else
            {
                this.filteredGoals = this.goals.filter(element => {
                return (element.name).includes(this.search)});
            }
        },
        async createGoal() {
            if(this.name !=null && this.name != "")
            await axios
                .post("/admin/treatment/createGoal", {
                    name: this.name
                }).then(()=>{
                    this.sync();
                    this.name = null;
                })
        },
        async deleteItem(item) {
            await axios
                .post("/admin/treatment/deleteGoals", item).then(()=>{
                    this.sync();
                })
        },
        async sync() {
            await axios
                .get("/admin/treatment/getGoals").then((res)=>{
                    this.goals = res.data.sort((a, b) => {
  const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
  const nameB = b.name.toUpperCase();

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0; // Names are equal
});

                    this.filteredGoals = res.data.sort((a, b) => {
  const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
  const nameB = b.name.toUpperCase();

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0; // Names are equal
});
;;
                })
        },
    },
    created() {
        this.sync();
    }
}
</script>
<style lang="scss" scoped></style>